<template>
    <div>
        <div class="row">
            <h2>{{ getTranslation('lbl_my_profile_headline') }}</h2>
            <div class="col-md-4">
                <form @submit.prevent="save">
                    <div class="form-group">
                        <label for="firstName">{{ getTranslation('lbl_user_first_name') }} *</label>
                        <input
                                type="text"
                                id="firstName"
                                class="form-control"
                                formControlName="firstName"
                                v-model="user.firstName">
                    </div>
                    <div class="form-group">
                        <label for="lastName">{{ getTranslation('lbl_user_last_name') }} </label>
                        <input
                                type="text"
                                id="lastName"
                                class="form-control"
                                formControlName="lastName"
                                v-model="user.lastName">
                    </div>
                    <div class="form-group">
                        <label for="email">{{ getTranslation('lbl_user_mail') }} *</label>
                        <input
                                type="email"
                                id="email"
                                class="form-control"
                                formControlName="email"
                                v-model="user.email"
                                >
                    </div>

                    <div class="form-group">
                        <label for="langSelector">{{ getTranslation('lbl_language') }}</label>
                        <div class="dropdown" v-on-clickaway="dropClose" :class="{ open: isOpened }"
                             id="langSelector">
                            <button class="dropdown-toggle form-control" @click.prevent="dropToggle" type="button" >
                                {{ langString }}
                                <span class="caret"></span></a>
                            </button>
                            <ul class="dropdown-menu" @click="dropToggle">
                                <li><a href="#" @click.prevent="setMyLanguage('de');">{{
                                    getTranslation('lbl_deutsch') }}</a></li>
                                <li><a href="#" @click.prevent="setMyLanguage('en');">{{
                                    getTranslation('lbl_english') }}</a></li>
                                </li>
                            </ul>
                        </div>
                    </div>

                    <div class="divider"></div>
                    <button
                            @click.prevent="save"
                            class="btn btn-primary"
                            type="submit"
                            >{{ getTranslation('button_label_submit') }}</button>
                    <router-link to="/" tag="button" class="btn pull-right">
                        {{ getTranslation('app_lbl_action_cancel') }}
                    </router-link>

                </form>
            </div>

            <div class="col-md-4">
                <div class="well">
                    <h2>{{ getTranslation('headline_change_password') }}</h2>
                    <form name="chnPsw" @submit.prevent="changePsw">
                        <div class="form-group">
                            <label for="psw_original">{{ getTranslation('frm_lbl_old_password') }}</label>
                            <input
                                    type="password"
                                    id="psw_original"
                                    class="form-control"
                                    autocomplete="new-password"
                                    formControlName="psw_original"
                                    v-model="psw_original">
                        </div>
                        <div class="form-group">
                            <label for="psw_set_1">{{ getTranslation('frm_lbl_new_password_1') }}</label>
                            <input
                                    type="password"
                                    id="psw_set_1"
                                    class="form-control"
                                    formControlName="psw_set_1"
                                    v-model="psw_set_1">
                        </div>
                        <div class="form-group">
                            <label for="psw_set_2">{{ getTranslation('frm_lbl_new_password_2') }}</label>
                            <input
                                    type="password"
                                    id="psw_set_2"
                                    class="form-control"
                                    formControlName="psw_set_2"
                                    v-model="psw_set_2">
                        </div>



                        <button
                                @click.prevent="changePsw"
                                class="btn btn-primary"
                                type="submit"
                                >
                            {{ getTranslation('btn_lbl_save_new_password') }}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import { mainEventBus } from '../../../../main';
    import { translationMixin } from '../../../../Banet/mixins/translationMixin.js';
//    import { userMixin } from '../../../../Banet/mixins/userMixin.js';
    import { dropdownMixin } from '../../../../Banet/mixins/dropdownMixin.js';
    import { mixin as clickaway } from 'vue-clickaway';

    export default {
        mixins: [ translationMixin, dropdownMixin, clickaway ],
        created: function(){
            this.$socket.emit('getMyProfile');
        },
        sockets: {
           refreshContent() {
               this.$socket.emit('getMyProfile');
           },
           user_missing_data(){
              mainEventBus.$emit('alert', {type: 'error', msg: 'msg_user_missing_data'});
           },
            myProfile: function(data){
                this.user = data;
                console.log('DATA', data);
            },
            usersChanged: function(user){
                this.$store.dispatch('setUserData', user);
                this.setLanguage(user.language);
                 mainEventBus.$emit('alert', {type: 'info', msg: 'msg_profile_updated'});
                 this.$router.push("/");
            },
            passwordUpdated: function(){
                this.psw_original = '';
                this.psw_set_1 = '';
                this.psw_set_2 = '';
               mainEventBus.$emit('alert', {type: 'info', msg: 'msg_pass_updated'});
            },
           wrongPassword(){
              mainEventBus.$emit('alert', {type: 'error', msg: 'lbl_invalid_login_credentials'});
           }
        },
        data: function () {
            return {
                alertData: {},
                user: {
                    firstName: '',
                    lastName: '',
                    email: '',
                    language: 'de'
                },
                msgBody: '',
                psw_original: '',
                psw_set_1: '',
                psw_set_2: ''
            }
        },
        computed: {

        },
        methods: {
            refreshSocket() {
                this.$http.post('refresh').then(res=>{
                    console.log('REFRESH');
                });
            },
            save: function(){
                this.$socket.emit('myProfileUpdate', this.user);
                this.refreshSocket();
            },
            setRole: function(role){
                this.user.role = role;
            },
            setMyLanguage: function(lang){
                this.user.language = lang;
            },
            changePsw: function(){
                if(!this.psw_original || !this.psw_set_1 || !this.psw_set_2){
                    mainEventBus.$emit('alert', {type:'warning', msg:'warning_lbl_all_required'});
                    return false;
                }
                if(this.psw_set_1 != this.psw_set_2){
                    mainEventBus.$emit('alert', {type:'warning', msg:'warning_lbl_passwords_must_be_equal'});
                    return false;
                }
                if(this.psw_original == this.psw_set_1 && this.psw_set_1 == this.psw_set_2){
                    mainEventBus.$emit('alert', {type:'info', msg:'warning_lbl_nothing_changed'});
                    return false;
                }
                var newCredentials = {
                    oldPassword: this.psw_original,
                    password: this.psw_set_1
                };

                this.$socket.emit('setPassword', newCredentials);
            }
        }
    }
</script>


<style scoped>
    .dropdown {
        width: 100%;
    }
    .dropdown .caret {
        position: absolute;
        top: 10px;
        right: 10px;
    }
    .dropdown .dropdown-toggle {
        width: 100%;
        text-align: left;
    }

    .dropdown-menu {
        width: 100%;
        margin-top: -1px;
    }
</style>


// WEBPACK FOOTER //
// MyProfile.vue?28044d50